import { render, staticRenderFns } from "./Tradingview.vue?vue&type=template&id=6591d8c6&scoped=true"
import script from "./Tradingview.vue?vue&type=script&lang=js"
export * from "./Tradingview.vue?vue&type=script&lang=js"
import style0 from "./Tradingview.vue?vue&type=style&index=0&id=6591d8c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6591d8c6",
  null
  
)

export default component.exports